/**
 * Vanilla Splitlines
 *
 * Splits text into line-breaks for delayed animations
 *
 * converted from: https://github.com/jeremyharris/split_lines
 *
 * @version 1.0.0
 * @author Arslan Akram <arslan@pixelative.co>
 * @copyright 2021, Pixelative <pixelative.co>
 */

/**
 * Creates a temporary clone
 *
 * @param element element The element to clone
 */
function _createTemp(el, width = null) {
  var clone = el.cloneNode(true);
  clone.style.position = 'absolute';
  clone.innerHTML = '';
  if (width != null) clone.style.width = `${width}px`;
  el.append(clone);
  return el.lastChild;
}

/**
 * Splits words by spaces
 *
 * @param string text The text to split
 */
function _splitWords(text) {
  return text.split(/\s+/);
}

/**
 * Splits contents into words, keeping their original Html tag. Note that this
 * tags *each* word with the tag it was found in, so when the wrapping begins
 * the tags stay intact. This may have an effect on your styles (say, if you have
 * margin, each word will inherit those styles).
 *
 * @param node contents The contents
 */
function _splitHtmlWords(contents) {
  var words = [];
  var splitContent;
  for (var c = 0; c < contents.length; c++) {
    if (contents[c].nodeName === 'BR') {
      words.push('<br>');
      continue;
    }
    if (contents[c].nodeType == 3) {
      splitContent = _splitWords(contents[c].textContent || contents[c].toString());
    } else {
      var tag = contents[c].cloneNode(true);
      splitContent = _splitHtmlWords(tag.childNodes);
      for (var t = 0; t < splitContent.length; t++) {
        tag.innerHTML = splitContent[t];
        splitContent[t] = tag.outerHTML;
      }
    }
    for (var w = 0; w < splitContent.length; w++) {
      if (splitContent[w] === '') {
        continue;
      }
      words.push(splitContent[w]);
    }
  }
  return words;
}

/**
 * Formats html with tags and wrappers.
 *
 * @param html content wrapped by the tag
 * @param index Current line index
 * @param baseDelay data-delay property on the element to set css transition delay
 */
function _markupContent(html, index, baseDelay) {
  var tag = document.createElement('div');
  tag.style.setProperty('--line-index', index);
  var delay = index / 7.5;
  if (baseDelay == null) {
    var finalDelay = delay + 's';
  } else {
    var finalDelay = parseFloat(baseDelay) + delay + 's';
  }
  tag.innerHTML = `<span class="split-line" style="transition-delay: ${finalDelay};">${html}</span>`;
  return tag;
}

/**
 * Initialize Split Lines
 *
 * @param el HTML element
 * @param baseDelay data-delay property on the element to set css transition delay
 */
var initSplitLines = function (el, baseDelay) {
  var ogContent = el.innerHTML,
    runSplitLines;
  runSplitLines = function (el, baseDelay) {
    el.innerHTML = ogContent;
    var width = el.offsetWidth,
      maxHeight,
      contents,
      newHtml,
      tempLine;

    // 1. Create an empty el clone: newHTml, and set maxHeight
    newHtml = _createTemp(el);
    newHtml.innerHTML = '42';
    maxHeight = newHtml.offsetHeight + 2;
    newHtml.innerHTML = '';

    // 2. Create an empty el clone: tempLine, and set its width
    tempLine = _createTemp(el, width);

    // 3. Setup contents: Remove last 2 elements in childNodes & convert to array
    contents = Array.from(el.cloneNode(true).childNodes);
    contents.pop();
    contents.pop();
    var words = _splitHtmlWords(contents);
    var lineCount = 0;
    for (var w = 0; w < words.length; w++) {
      var html = tempLine.innerHTML;
      tempLine.innerHTML = html + words[w] + ' ';
      if (tempLine.clientHeight > maxHeight) {
        tempLine.innerHTML = html;
        newHtml.append(_markupContent(tempLine.innerHTML, lineCount, baseDelay));
        tempLine.innerHTML = '';
        w--;
        lineCount++;
      }
    }

    // PERFECT TILL HERE
    newHtml.append(_markupContent(tempLine.innerHTML, lineCount, baseDelay));
    el.innerHTML = newHtml.innerHTML;
  };
  runSplitLines(el, baseDelay);
  window.addEventListener('resize', function () {
    runSplitLines(el, baseDelay);
  });
};

/**
 * Attach initSplitLines to Elements
 */
setTimeout(function () {
  window.addEventListener('load', () => {
    const slEL = document.querySelectorAll('.lines-up, .lines-down, .lines-fade-up, .lines-fade-down');
    // Do something with slEL here
    if (slEL) {
      slEL.forEach(function (el) {
        initSplitLines(el, el.style.transitionDelay);
      });
    }
  });
}, 1000);